var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "app-main-content" }, [
    _c(
      "div",
      {
        staticClass: "app-main-inner-tab",
        staticStyle: {
          "flex-grow": "1",
          display: "flex",
          "flex-direction": "column"
        }
      },
      [
        _c(
          "el-tabs",
          {
            staticStyle: { width: "100%", height: "100%" },
            attrs: { type: "card" },
            on: { "tab-click": _vm.handleTabClick },
            model: {
              value: _vm.activeTabName,
              callback: function($$v) {
                _vm.activeTabName = $$v
              },
              expression: "activeTabName"
            }
          },
          [
            _c(
              "el-tab-pane",
              {
                attrs: {
                  lazy: true,
                  label: _vm.$t("CargoMsg.Cargo_BusinessStatusManagement"),
                  name: "businessStatusManagement"
                }
              },
              [
                _c("tenant-business-status-management", {
                  ref: "businessStatusManagement"
                })
              ],
              1
            ),
            _c(
              "el-tab-pane",
              {
                attrs: {
                  lazy: true,
                  label: _vm.$t("CargoMsg.Cargo_TriggerTypeManagement"),
                  name: "triggerTypeManagement"
                }
              },
              [_c("trigger-type-management")],
              1
            ),
            _c(
              "el-tab-pane",
              {
                attrs: {
                  lazy: true,
                  label: _vm.$t(
                    "CargoMsg.Cargo_OperationInstructionsManagement"
                  ),
                  name: "operationInstructionsManagement"
                }
              },
              [
                _vm.isPlatform
                  ? _c("div", [_c("platform-instruction")], 1)
                  : _c(
                      "div",
                      [
                        _c("tenant-instruction-wrap", {
                          ref: "tenantInstructionWrap"
                        })
                      ],
                      1
                    )
              ]
            ),
            _c(
              "el-tab-pane",
              {
                attrs: {
                  lazy: true,
                  label: _vm.$t("SystemMaintenance.ServiceScenarioApplication"),
                  name: "specificBusinessRule"
                }
              },
              [_c("specific-business-rule")],
              1
            ),
            _c(
              "el-tab-pane",
              {
                attrs: {
                  lazy: true,
                  label: _vm.$t("CargoMsg.Cargo_WarnRuleConfiguration"),
                  name: "warnRuleConfiguration"
                }
              },
              [_c("warn-rule-configuration")],
              1
            )
          ],
          1
        )
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }